"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _core = require("@material-ui/core");

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _jsxRuntime = require("react/jsx-runtime");

function TextCheckbox(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
    error: props.error,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Checkbox, {
        checked: props.checked,
        onChange: props.onChange,
        disabled: props.disabled
      }),
      className: props.error ? 'error' : '',
      label: props.label
    }), props.helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormHelperText, {
      error: props.error,
      children: props.helperText
    })]
  });
}

TextCheckbox.defaultProps = {
  disabled: false
};
TextCheckbox.propTypes = {
  error: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
var _default = TextCheckbox;
exports.default = _default;
//# sourceMappingURL=TextCheckbox.js.map